import React, {useState, useEffect, Fragment} from 'react'
import {useHistory} from 'react-router-dom';
import { currentLang } from '../../../utils/functions';
import { useTranslation } from 'react-i18next';

const Pagination = ({url, data, loadData, filterType, curPage}) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [pages, setPages] = useState([]);
    const [totalPages, setTotalPages] = useState(0)
    const history = useHistory();
    const { t } = useTranslation();
    
    useEffect(() => {
        //console.log(data);
        const total = data.total;
        const perPage = data.per_page;
        
        setTotalPages(Math.ceil(total/perPage));

        
    }, [data])

    useEffect(() => {
        if(totalPages){
            setPages(new Array(totalPages).fill(0));
        }

    }, [totalPages])

    useEffect(() => {
        if(curPage){
            setCurrentPage(parseInt(curPage));
        }else{
            setCurrentPage(1);
        }
        
    }, [curPage])

    const handleClick = (pageNumber) =>{
        if(pageNumber > 0 && pageNumber != currentPage && pageNumber <= totalPages){
            loadData({"pageNumber": pageNumber, "value": filterType});
            setCurrentPage(pageNumber);
            var pageURL = url;
            if(filterType){
                pageURL += t(filterType)+"/";
            }
            history.push(pageURL+pageNumber);
        }
    }

    return (
        <Fragment>
            {pages && totalPages > 1 &&
            <ul className="pagination">
                <li onClick={()=>handleClick(currentPage-1)}>
                    <a className={`pagination__prev ${currentPage === 1 ? "disabled" : ""}`}>
                        <i className="icon-back"></i>
                    </a>
                </li>

                    <Fragment>
                    {pages.map((item, index)=>{
                        var i = index+1;
                        
                        return (
                            <li key={i} className={currentPage === i ? "active number" : "number"} onClick={()=>handleClick(i)}><a className="pagination__number">{i}</a></li>
                        )
                    })}
                    </Fragment>

                <li onClick={()=>handleClick(currentPage+1)}><a className={`pagination__next ${currentPage === totalPages ? "disabled" : ""}`}><i className="icon-back"></i></a></li>
            </ul>
            }
        </Fragment>
    )
}

export default Pagination
